import { useActivitiesContext } from '../../../../context'
import type { ActivityDetails } from '../../../../typings'
import { useMemo } from 'react'
import { useLocalizationDateFormat } from '@user/features/Localization/useLocalizationDateFormat'
import { timeFormat } from '@sales-center/common'

type Props = {
  current?: ActivityDetails
}

export function useData(props: Props) {
  const { current } = props
  const [{ activityTypes }] = useActivitiesContext()
  const { formatDate } = useLocalizationDateFormat()

  const activityType = useMemo(() => {
    return activityTypes.find((type) => type.id === current?.activityTypeId)
  }, [current, activityTypes])

  const dueDate = useMemo(
    () =>
      current?.dueDate
        ? formatDate(current?.dueDate) + ' - ' + timeFormat(current?.dueDate)
        : '',
    [current, formatDate],
  )

  const startDate = useMemo(
    () =>
      current?.startDate
        ? formatDate(current?.startDate) +
          ' - ' +
          timeFormat(current?.startDate)
        : '',
    [current, formatDate],
  )

  const owner = useMemo(() => {
    if (current?.owner) {
      if (current.ownerIsActive === false) {
        return current.owner + ' (Inactive)'
      }
      return current.owner
    }
    return 'Unassigned'
  }, [current])

  return {
    owner,
    activityType,
    dueDate,
    startDate,
  }
}
